
  import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
  export default class FieldTitle extends Vue {
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: Boolean, default: false }) center!: boolean
  }
